import ReportPageTemplate from "./Components/ReportPageTemplate";

export default function FrontOfficeReports() {
  const reportTypes = [
    { label: "Blocked Rooms", api: "/pms/reports/blocked-rooms" },
    { label: "Guest Checked In", api: "/pms/reports/guest-checked-in" },
    { label: "Guest Checked Out", api: "/pms/reports/guest-checked-out" },
    { label: "Guest List", api: "/pms/reports/guest-list" },
    { label: "Room Availability", api: "/pms/reports/room-availability" },
    { label: "Night Audit Summary", api: "/pms/reports/night-audit-summary" },
  ];

  return (
    <ReportPageTemplate
      title="Front Office Reports"
      desc="Guest activity, night audit, room movement & more"
      reportTypes={reportTypes}
    />
  );
}
